module.exports = __webpack_public_path__ + "static/media/background-blue-mobile.24940af9.svg";